export const judgeIsMobile = (word, AesKey) => {
  let browser = {
    versions: (function() {
      var u = navigator.userAgent,
        app = navigator.appVersion
      return {
        //移动终端浏览器版本信息
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('UCBrowser') > -1, //android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1 //是否web应用程序，没有头部与底部
      }
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  }
  //如果是移动端就进这里
  if (browser.versions.mobile || browser.versions.ios || browser.versions.android || browser.versions.iPhone || browser.versions.iPad) {
    return true
  } else {
    return false
  }
}

//判断是哪个浏览器
export const getBrowser = () => {
  //qqbrowser 其他APP内嵌浏览器 360安全浏览器、360极速浏览器
  var UserAgent = navigator.userAgent.toLowerCase()
  //documentMode 是一个IE的私有属性，在IE8+中被支持。
  if (/micromessenger/.test(UserAgent)) {
    return '微信内嵌浏览器'
  }
  const getOpenType = () => {
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
      return 'mobile'
    } else {
      return 'pc'
    }
  }
  if (getOpenType() == 'mobile') {
    if (/alipayclient/.test(UserAgent)) {
      // AlipayClient
      return '其他APP内嵌浏览器'
    } else if (/qq/.test(UserAgent)) {
      // AlipayClient
      return '其他APP内嵌浏览器'
    }
  }
  if (window.document.documentMode) {
    return 'IE'
  }
  if (/firefox/.test(UserAgent)) return 'FireFox'
  if (/opera/.test(UserAgent)) return 'Opera'
  if (/qqbrowser/.test(UserAgent) || /tencenttraveler/.test(UserAgent)) return 'QQ浏览器'
  if (/safari/.test(UserAgent)) return 'Safari'
  // if ((/chrome/.test(UserAgent) && _mime('type', 'application/vnd.chromium.remoting-viewer')) || /gecko/.test(UserAgent)) return '360浏览器'
  if (/360ee/.test(UserAgent)) return '360极速浏览器'
  if (/360se/.test(UserAgent)) return '360安全浏览器'
  if (/metasr/.test(UserAgent)) return '搜狗浏览器'
  if (/chrome/.test(UserAgent)) return 'Chrome'
  return '其他'
}

export const getStrByteCount = (value) => {
  if (!value) {
    return 0
  }
  let count = 0
  for (let i = 0; i < value.length; i++) {
    if (value.charCodeAt(i) > 255) {
      count += 2
    } else {
      count++
    }
  }
  return count
}

export const isIllegalWord = function(articleName) {
  // const patern = /[`~!@#$%^&*+<>?:"{},\/;']/im
  // ，。？！：；·…~&@#
  // .?!:;、……～＆＠＃-·
  // “”‘’〝〞 "'＂＇´＇()【】《》＜＞﹝﹞<>()[]«»›‹〕〔〈〉{}［］「」｛｝〖〗『』/|_
  const patern = /^[A-Za-z0-9\u4e00-\u9fa5\s\.\?\-（）《》【】\[\]——，、。？！：；+·…~&@#:;!……～＆＠＃“”‘’〝〞"'＂＇´＇\(\)＜＞﹝﹞\<\>«»›‹〕〔〈〉\{\}［］「」｛｝〖〗『』\/\|_]+$/im
  return !patern.test(articleName)
}

export const isSimpleIllegalWord = function(articleName) {
  const patern = /^[^/\:*"?<>|]*$/g
  return !patern.test(articleName)
}

export const judgeBigScreen = function() {
  //这里根据返回值 true 或false ,返回true的话 则为 ios 全面屏
  let result = false
  const rate = window.screen.height / window.screen.width
  let limit = window.screen.height == window.screen.availHeight ? 1.8 : 1.65 // 临界判断值
  if (rate > limit) {
    result = true
  }
  return result && window.navigator.userAgent.indexOf('iPhone') > -1
}

export const judgeMI8 = function() {
  return window.navigator.userAgent.indexOf('MI 8') > -1 || window.navigator.userAgent.indexOf('iPhone') > -1
}

import apis from './api/login'
import moment from 'moment'
export const isLogin = async function() {
  await apis.login().then((res) => {
    if (res && res.data && res.status === 200) {
      let data = res.data
      if (data.code === 101) {
        localStorage.setItem('username', '')
        window.location.href = data.data + '?service=' + window.encodeURIComponent(window.location.href)
      } else if (data.data) {
        localStorage.setItem('username', data.data.username)
      }
    }
  })
}
// 判断查询字符串id是否加密,如果加密需要解密、不加密直接返回原值
export const isPureNum = function(payload) {
  const numReg = /^\d{1,}$/
  if (numReg.test(payload) || typeof payload === 'undefined') {
    return payload
  } else {
    let id
    try {
      const baseId = decodeURIComponent(payload)
      id = window.atob(baseId)
    } catch (error) {
      console.log(error.name + ':' + error.message)
      const baseId = decodeURIComponent(payload)
      const curid = decodeURIComponent(baseId)
      const cur_id = decodeURIComponent(curid)
      id = window.atob(cur_id)
    }
    return id
  }
}

export const getByteLength = function(str) {
  let byteCount = 0
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i)
    if (charCode < 0x80) byteCount += 1
    else if (charCode < 0x800) byteCount += 2
    else if (charCode < 0xd800 || charCode >= 0xe000) byteCount += 3
    else i += 1 // UTF-16 surrogate pairs
  }
  return byteCount
}

//id加密
export const setEncryption = function(payload) {
  // const baseid = window.btoa(payload)
  // const encryptId = encodeURIComponent(baseid)
  // return baseid
  return payload
}
//英文人名转中文
export const convertEnName = function(text) {
  return text
    .replaceAll(/xi jinping/gi, '习近平')
    .replaceAll(/He Lifeng/gi, '何立峰')
    .replaceAll(/Li Qiang/gi, '李强')
    .replaceAll(/Wang Yi/gi, '王毅')
    .replaceAll(/li ganjie/gi, '李干杰')
    .replaceAll(/Li Xi/gi, '李希')
    .replaceAll(/Cai Qi/gi, '蔡奇')
    .replaceAll(/Shi Taifeng/gi, '石泰峰')
    .replaceAll(/He Weidong/gi, '何卫东')
    .replaceAll(/Zhang Youxia/gi, '张又侠')
    .replaceAll(/Wang Huning/gi, '王沪宁')
    .replaceAll(/Ding Xuexiang/gi, '丁薛祥')
    .replaceAll(/Zhao Leji/gi, '赵乐际')
    .replaceAll(/Ma Xingrui/gi, '马兴瑞')
    .replaceAll(/Chen Miner/gi, '陈敏尔')
    .replaceAll(/Li Shulei/gi, '李书磊')
    .replaceAll(/Yuan Jiajun/gi, '袁家军')
    .replaceAll(/Zhang Guoqing/gi, '张国清')
    .replaceAll(/Liu Guozhong/gi, '刘国中')
    .replaceAll(/Li Hongzhong/gi, '李鸿忠')
    .replaceAll(/Chen Wenqing/gi, '陈文清')
    .replaceAll(/Chen Jining/gi, '陈吉宁')
    .replaceAll(/Huang Kunming/gi, '黄坤明')
    .replaceAll(/Yin Li/gi, '尹力')
}

// 获取当前日期yy-mm-dd格式
export const getCurDate = function() {
  const myDate = new Date()
  const year = myDate.getFullYear() //当前年
  const month = myDate.getMonth() + 1 //当前月
  const day = myDate.getDate() //当前天
  const lastMonth = isSingle(month)
  const lastDay = isSingle(day)
  return {
    year: year,
    curDate: year + '-' + lastMonth + '-' + lastDay
  }
}
// 判断月份日期是否是单数
function isSingle(payload) {
  if (String(payload).length == 1) {
    return '0' + payload
  } else {
    return payload
  }
}

export const base64ToFile = function(base64) {
  var arr = base64.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1]) // 解码base-64编码的数据
  var n = bstr.length
  var u8arr = new Uint8Array(n) // 无符号整型数组
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  //转换成file对象
  let filename = new Date().getTime() + '.png'
  let filetest = new File([u8arr], filename, { type: mime })
  return filetest
}
// 把图片绝对路径切成相对路径
export const sliceStrPicUrl = function(val) {
  let res = ''
  if (val.includes('http') || val.startsWith('//')) {
    try {
      let exp = /attach.*/g
      res = val.match(exp)[0]
    } catch (error) {
      let exp = /ebook.*/g
      res = val.match(exp)[0]
    }
  } else {
    res = val
  }
  return res
}
// 格式化数字报文章
export const formatDigitalArticle = function(res) {
  if (res.data.data.title) {
    res.data.data.title = initDigitalArticleTitle(res.data.data.title)
  }
  if ((res.data.data.content && res.data.data.content.substring(0, 24) !== '<div class="content_type') || !res.data.data.content) {
    res.data.data.content = initDigitalArticle(res)
  } else if (res.data.data.content) {
    res.data.data.content = repairDigitalArticleText(res.data.data.content)
  } else {
    res.data.data.content = ''
  }
  if (res.data.data.layoutType === 'picture' && res.data.data.title.trim() === '') {
    res.data.data.title = '图片新闻'
  }
  return res
}
// 初始化数字报文章标题
export const initDigitalArticleTitle = function(articleTitle) {
  articleTitle = articleTitle.trim()
  articleTitle = articleTitle.replace(/\n/g, '')
  return articleTitle
}
// 初始化数字报文章数据
export const initDigitalArticle = function(res) {
  // 去掉左右空格
  if (res.data.data.yinTi) {
    res.data.data.yinTi = res.data.data.yinTi.trim()
  }
  if (res.data.data.title) {
    res.data.data.title = res.data.data.title.trim()
  }
  if (res.data.data.subtitle) {
    res.data.data.subtitle = res.data.data.subtitle.trim()
  }
  let author = ''
  if (res.data.data.author) {
    author = res.data.data.author.trim()
  }
  if (res.data.data.correspondent) {
    res.data.data.correspondent = res.data.data.correspondent.trim()
  }
  if (res.data.data.columnName) {
    res.data.data.columnName = res.data.data.columnName.trim()
  }
  if (res.data.data.baoZhiName) {
    res.data.data.baoZhiName = res.data.data.baoZhiName.trim()
  }
  if (res.data.data.publishDate) {
    res.data.data.publishDate = moment(res.data.data.publishDate).format('YYYY-MM-DD')
  }
  if (res.data.data.caption) {
    res.data.data.caption = res.data.data.caption.trim()
    res.data.data.caption = res.data.data.caption.replace(/<p>/g, '')
    res.data.data.caption = res.data.data.caption.replace(/<\/p>/g, '')
  }
  if (res.data.data.layoutType === 'xiaoyang') {
    // 小样文章格式化
    let xiaoyangArray = []
    // 引题
    if (res.data.data.yinTi) {
      xiaoyangArray.push('<div class="content_type content_type_0001" data-content-type="content_type_0001" data-w-e-type="contenttype">' + res.data.data.yinTi.trim() + '</div>')
    }
    // 标题
    if (res.data.data.title) {
      xiaoyangArray.push('<div class="content_type content_type_0002" data-content-type="content_type_0002" data-w-e-type="contenttype">' + res.data.data.title.trim() + '</div>')
    }
    // 副题
    if (res.data.data.subtitle) {
      xiaoyangArray.push('<div class="content_type content_type_0003" data-content-type="content_type_0003" data-w-e-type="contenttype">' + res.data.data.subtitle.trim() + '</div>')
    }
    // 作者
    if (author || res.data.data.publishDate || res.data.data.baoZhiName) {
      xiaoyangArray.push(
        '<div class="content_type content_type_0005" data-content-type="content_type_0005" data-w-e-type="contenttype">' +
          res.data.data.baoZhiName +
          ' ' +
          author +
          ' ' +
          res.data.data.publishDate +
          '</div>'
      )
    }
    // 通讯员
    if (res.data.data.correspondent) {
      xiaoyangArray.push('<div class="content_type content_type_0007" data-content-type="content_type_0007" data-w-e-type="contenttype">' + res.data.data.correspondent.trim() + '</div>')
    }
    // 栏目
    if (res.data.data.columnName) {
      xiaoyangArray.push('<div class="content_type content_type_0007" data-content-type="content_type_0007" data-w-e-type="contenttype">' + res.data.data.columnName.trim() + '</div>')
    }
    // 附图
    if(res.data.data.futuList){
      let futuList = JSON.parse(res.data.data.futuList) || []
    for (let a in futuList) {
      if (futuList.hasOwnProperty(a)) {
        // 去掉左右空格
        if (futuList[a].yinTi) {
          futuList[a].yinTi = futuList[a].yinTi.trim()
        }
        if (futuList[a].title) {
          futuList[a].title = futuList[a].title.trim()
        }
        if (futuList[a].subtitle) {
          futuList[a].subtitle = futuList[a].subtitle.trim()
        }
        if (futuList[a].digest) {
          futuList[a].digest = futuList[a].digest.trim()
        }
        if (futuList[a].author) {
          futuList[a].author = futuList[a].author.trim()
        }
        if (futuList[a].correspondent) {
          futuList[a].correspondent = futuList[a].correspondent.trim()
        }
        if (futuList[a].columnName) {
          futuList[a].columnName = futuList[a].columnName.trim()
        }
        if (futuList[a].caption) {
          futuList[a].caption = futuList[a].caption.trim()
          futuList[a].caption = futuList[a].caption.replace(/<p>/g, '')
          futuList[a].caption = futuList[a].caption.replace(/<\/p>/g, '</br>')
          futuList[a].caption = futuList[a].caption.replace(/\n/g, '</br>')
        }
        // 引题
        /*if (futuList[a].yinTi) {
          xiaoyangArray.push('<div class="content_type content_type_0001" data-content-type="content_type_0001" data-w-e-type="contenttype">' + futuList[a].yinTi.trim() + '</div>')
        }
        // 标题
        if (futuList[a].title) {
          xiaoyangArray.push('<div class="content_type content_type_0002" data-content-type="content_type_0002" data-w-e-type="contenttype">' + futuList[a].title.trim() + '</div>')
        }
        // 副题
        if (futuList[a].subtitle) {
          xiaoyangArray.push('<div class="content_type content_type_0003" data-content-type="content_type_0003" data-w-e-type="contenttype">' + futuList[a].subtitle.trim() + '</div>')
        }*/
        // 摘要
        if (futuList[a].digest) {
          xiaoyangArray.push('<div class="content_type content_type_0004" data-content-type="content_type_0004" data-w-e-type="contenttype">' + futuList[a].digest.trim() + '</div>')
        }
        // 作者
        /*if (futuList[a].author) {
          xiaoyangArray.push('<div class="content_type content_type_0005" data-content-type="content_type_0005" data-w-e-type="contenttype">' + futuList[a].author.trim() + '</div>')
        }
        // 通讯员
        if (futuList[a].correspondent) {
          xiaoyangArray.push('<div class="content_type content_type_0007" data-content-type="content_type_0007" data-w-e-type="contenttype">' + futuList[a].correspondent.trim() + '</div>')
        }*/
        // 栏目
        if (futuList[a].columnName) {
          xiaoyangArray.push('<div class="content_type content_type_0007" data-content-type="content_type_0007" data-w-e-type="contenttype">' + futuList[a].columnName.trim() + '</div>')
        }
        // 图片
        let futuHtml = '<img src="' + futuList[a].standardPic.fileName + '" data-href="' + futuList[a].standardPic.fileName + '"　/>'
        // 图片说明
        xiaoyangArray.push('<div class="content_type content_type_0006" data-content-type="content_type_0006" data-w-e-type="contenttype">' + futuHtml + futuList[a].caption.trim() + '</div>')
      }
    }
    }
    
    // 内容
    // 如果内容不是富文本格式，则对内容进行格式化，让其转换为带HTML的富文本内容
    let contentArray = initDigitalHTMLContent(res.data.data.content, true).split('\n')
    for (let a in contentArray) {
      if (contentArray.hasOwnProperty(a)) {
        xiaoyangArray.push('<div class="content_type content_type_0007" data-content-type="content_type_0007" data-w-e-type="contenttype">' + contentArray[a].trim() + '</div>')
      }
    }
    // 结果输出
    return xiaoyangArray.join('')
  } else {
    // 图片文章格式化
    let picArray = []
    // 引题
    if (res.data.data.yinTi) {
      picArray.push('<div class="content_type content_type_0001" data-content-type="content_type_0001" data-w-e-type="contenttype">' + res.data.data.yinTi.trim() + '</div>')
    }
    // 标题
    if (res.data.data.title) {
      picArray.push('<div class="content_type content_type_0002" data-content-type="content_type_0002" data-w-e-type="contenttype">' + res.data.data.title.trim() + '</div>')
    }
    // 副题
    if (res.data.data.subtitle) {
      picArray.push('<div class="content_type content_type_0003" data-content-type="content_type_0003" data-w-e-type="contenttype">' + res.data.data.subtitle.trim() + '</div>')
    }
    // 作者
    if (res.data.data.author) {
      picArray.push('<div class="content_type content_type_0005" data-content-type="content_type_0005" data-w-e-type="contenttype">' + res.data.data.author.trim() + '</div>')
    }
    // 栏目
    if (res.data.data.columnName) {
      picArray.push('<div class="content_type content_type_0007" data-content-type="content_type_0007" data-w-e-type="contenttype">' + res.data.data.columnName.trim() + '</div>')
    }
    // 图片
    let futu = JSON.parse(res.data.data.content)
    let futuHtml = '<img src="' + futu.fileName + '" data-href="' + futu.fileName + '">'
    // 图片说明
    picArray.push(
      '<div class="content_type content_type_0006" data-content-type="content_type_0006" data-w-e-type="contenttype">' + futuHtml + initDigitalHTMLContent(res.data.data.caption.trim()) + '</div>'
    )
    // 结果输出
    return picArray.join('')
  }
}
// 初始化HTML内容
export const initDigitalHTMLContent = function(htmlContent, formatBr) {
  if (!htmlContent) {
    return ''
  }
  // 处理所有具有表示换行的标志，并将其统一转换为\n
  if (formatBr === true) {
    htmlContent = htmlContent.replace(/<\/p><p>/g, '\n')
    htmlContent = htmlContent.replace(/<\/p><p(.+?)>/g, '\n')
  }
  // 去掉所有HTML标签
  htmlContent = htmlContent.replace(/<[^>]+>/g, '')
  // 去掉所有特殊字符
  htmlContent = htmlContent.replace(/&nbsp;/g, '')
  return htmlContent.trim()
}
// 修复文章标题
export const repairDigitalArticleTitle = function(articleTitle) {
  articleTitle = articleTitle.trim()
  articleTitle = articleTitle.replace(/\n/g, '')
  return articleTitle
}
// 修复文章内容
export const repairDigitalArticleText = function(articleText) {
  // 去掉里面的P元素
  articleText = articleText.replace(/<p>/g, '')
  articleText = articleText.replace(/<\/p>/g, '')
  articleText = articleText.replace(/&nbsp;/g, '')
  // 如果存在content_type的双重包裹，则需要去除外部DIV
  let mark1 = '<div class="content_type content_type_0007" data-content-type="content_type_0007" data-w-e-type="contenttype"><div class="content_type'
  let mark2 = '<div class="content_type content_type_0007" data-content-type="content_type_0007" data-w-e-type="contenttype">'
  if (articleText.substring(0, mark1.length) === mark1) {
    // 这里主要处理wangeditor会在某些情况下给内容自动加入一层DIV进行包裹
    // 虽然文本内容没有变化，但HTML内容确发生变化，导致外部无法正确判断它是否真实被编辑过
    // 所以这里会进行数据修复，让其恢复到之前的内容
    return articleText.substring(mark2.length, articleText.length - 6)
  } else {
    return articleText
  }
}

import setBook from '@api/setBook'
//上传图片统一方法
export const uploadIconPic = async function(e, type, maxSize, component) {
  var _this = this
  //上传图片
  var file = e.target.files[0]
  if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
    return false
  }
  if (file.size > maxSize * 1024 * 1024) {
    component.$message({ message: `请上传小于${maxSize}M的图片`, type: 'error' })
    e.target.value = ''
    return false
  }
  let params = new FormData()
  params.append('fieldName', type)
  params.append(type, file)
  let imageList = []
  await setBook.uploadPicture(params).then(async (res) => {
    if (res.status === 200 && res.data.code === 0) {
      await setBook.getImageList({ module: type }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          imageList = res.data.data
        } else {
          console.log('获取图片列表失败')
        }
      })
    } else {
      e.target.value = ''
      this.$message({
        message: res.data.msg || '图片上传失败',
        type: 'error'
      })
      console.log('上传失败')
    }
  })
  return imageList
}
